import createIcon from '../../createIcon';

/**
 * @component @name VoiceChat
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIgMi45IDIgNFYyMkw2IDE4SDIwQzIxLjEgMTggMjIgMTcuMSAyMiAxNlY0QzIyIDIuOSAyMS4xIDIgMjAgMlpNMjAgMTZINkw0IDE4VjRIMjBWMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuNzUgNUgxMS4yNVYxNUgxMi43NVY1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDdIOC41VjEzSDEwVjdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy41IDlINlYxMUg3LjVWOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNS41IDdIMTRWMTNIMTUuNVY3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDlIMTYuNVYxMUgxOFY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VoiceChat = createIcon('VoiceChat', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z',
      key: '83u51f',
    },
  ],
  ['path', { d: 'M12.75 5H11.25V15H12.75V5Z', key: 'lah6ji' }],
  ['path', { d: 'M10 7H8.5V13H10V7Z', key: '17jz04' }],
  ['path', { d: 'M7.5 9H6V11H7.5V9Z', key: '1ugo54' }],
  ['path', { d: 'M15.5 7H14V13H15.5V7Z', key: '1gpr9h' }],
  ['path', { d: 'M18 9H16.5V11H18V9Z', key: '1dbtm3' }],
]);

export default VoiceChat;
